import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import PasskeyVerification from '@modules/passkey/components/PasskeyVerification';

const PasskeySsoPage = () => {
  return (
    <ContentLayout testId="PasskeySsoPage">
      <PasskeyVerification />
    </ContentLayout>
  );
};

export default PasskeySsoPage;
